import { useEffect } from "react";

//In the StationsPageTable, when resizing datagrid columns using the dragable column header, when a column is pulled to the right and allowed more horizontal space
//if data in the cells attempts to reduce the number of verticle rows it takes up to be a number less than what the data had when it originally rendered,
//then the program crashes with an error 'ResizeObserver loop completed with undelivered notifications'
//As far as I am aware, the program is fine and the error itself is the problem
//This function prevents that error from being thrown and crashing the program
//If you know how to fix this in a better way, then please do!
function handleResizeError(e) {
    if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
        const resizeObserverErrDiv = document.getElementById(
            'webpack-dev-server-client-overlay-div'
        );
        const resizeObserverErr = document.getElementById(
            'webpack-dev-server-client-overlay'
        );
        if (resizeObserverErr) {
            resizeObserverErr.setAttribute('style', 'display: none');
        }
        if (resizeObserverErrDiv) {
            resizeObserverErrDiv.setAttribute('style', 'display: none');
        }
    }
}


export const useHandleResizeError = () => {
    useEffect(() => {
      window.addEventListener('error', handleResizeError)
      return () => {window.addEventListener('error', handleResizeError)}
    }, [])
}
